import axios from "axios";
import baseURL, { ticketBaseURL } from "../configs/api";

export const getEmailCheckingFromJVCRM = (email: string) => {
    return getFetchFromJVCRM(`rdRentalTenantUsers/DoesEmailExist?email=${encodeURIComponent(email)}`);
}

const getFetchFromJVCRM = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        headers: {         
            'Content-Type': 'application/json'
        },
        params: params
    }).then(response => response.data);
}

export const getEmailChecking = (email: string, tenantId: string) => {
    return getFetch(`users/DoesEmailExist?email=${encodeURIComponent(email)}`, tenantId);
}

export const getCustomerEmailChecking = (email: string, tenantId: string) => {
    return getFetch(`Customer/DoesCustomerEmailExist?email=${encodeURIComponent(email)}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            'Content-Type': 'application/json'
        },
        params: params
    }).then(response => response.data);
}